import http from '@/libs/http'
export default class FacturasValorService {
  getFacturasValor (payload) {
    return http.post(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/facturas/generar-valor`, payload)
  }
}
